export default "__VITE_PUBLIC_ASSET__56abf496__"